@if (isShow) {
  <section class='bottom-popover'>
    <div class='close' id="close" (click)='dismiss($event)'><i class='icon-requisition-denied'>&nbsp;</i></div>
    @if (!popOverMessage) {
      <div class='count'>{{count}} {{itemPlural}} {{'common.selected' | translate}}</div>
    }
    @if (popOverMessage) {
      <div class='count'>{{count}} {{message}}</div>
    }
    @if (add) {
      <div class='add' id="add" (click)='addItems($event)'><i class='icon-requisition-finalized'>&nbsp;</i></div>
    }
    @if (delete || reverse) {
      <div class='del' id="del" (click)='batchCancel($event)'><i [ngClass]="{'icon-delete':delete,'icon-load':reverse}" id="iconDelete">&nbsp;</i></div>
    }
    @if (suggest) {
      <div class='suggest' id="suggest" (click)='autoSuggest($event)'><i class='icon-suggest-quantities'>&nbsp;</i></div>
    }
    @if (sync) {
      <div class='sync' id="sync" [ngClass]="{'disableIcon':disableSync}"(click)='syncClicked($event)'><i class='icon-sync'>&nbsp;</i></div>
    }
    @if (approve) {
      <div class='approve' id="approve" (click)="iconClick($event,'approve')"><i class='icon-tick'>&nbsp;</i></div>
    }
    @if (deny) {
      <div class='deny' id="deny" (click)="iconClick($event,'deny')"><i class='icon-remove'>&nbsp;</i></div>
    }
    @if (hold) {
      <div class='hold' id="hold" (click)="iconClick($event,'hold')"><i class='icon-requisition-on-hold'>&nbsp;</i></div>
    }
    @if (suspend) {
      <div class='suspend' id="suspend" (click)="batchCancel($event)"><i class='icon-suspend'>&nbsp;</i></div>
    }
  </section>
}